<template>
    <div name="" class="wrapper" >
        <loading v-if="isLoading" />
        <div class="contents">
            <div class="result-header">
                <img style="width: 22px;cursor: pointer;" src="../../../../assets/close.png" @click="onClose" />
                <!-- <div class="custom-button-1">
                    고객센터 문의
                </div> -->
            </div>
            <div id="calculate-result" style="width: 100%;">
                <div class="selected-area">
                    <div class="selected-area-info">
                        <div class="selected-info-row">
                            <span class="selected-info-label">환자 유형</span>
                            <span class="selected-info-value">{{convertDiabetesType(diseaseType)}}</span>
                        </div>
                        <!-- <div class="selected-info-row" style="margin-top: 8px;">
                            <span class="selected-info-label">나이</span>
                            <span class="selected-info-value">{{ isAdult ? '만 19세 이상' : '만 19세 미만' }}<span v-if="autoInjector">/ 미니메드 780G 사용</span></span>
                        </div> -->
                        <div class="selected-info-row" style="margin-top: 8px;">
                            <span class="selected-info-label">품목</span>
                            <span class="selected-info-value">{{ convertTypeToString(type) }}</span>
                        </div>
                        <div class="selected-info-row" style="margin-top: 8px;">
                            <span class="selected-info-label">처방일수</span>
                            <span class="selected-info-value">{{ dosageDay }}</span>
                        </div>
                    </div>
                </div>
                <div class="product-area">
                    <span class="product-title" style="margin-bottom: 20px;">제품 정보</span>
                    <div class="selected-info-row" style="margin-bottom: 16px;" v-for="(product, index) in selectedItems">
                        <span class="product-name">{{ product.name }}</span>
                        <span class="product-count">{{selectedCount[index]}}개</span>
                    </div>
                </div>
                <div class="payment-area">
                    <div class="payment-title">카테터 비용 계산</div>
                    <div class="selected-info-row" style="padding: 0 16px; margin-top: 16px;" >
                        <span class="font-18-400-black">총액</span>
                        <span class="font-18-400-black">{{setComma(maxPrice + etcPrice)}}원</span>
                    </div>
                    <div class="selected-info-row" style="padding: 0 16px; margin-top: 16px;">
                        <span class="font-18-400-black">공단 지원대상</span>
                    </div>
                    <div class="selected-info-row" style="padding: 0 16px; margin-top: 8px;">
                        <span class="font-18-400-gray">공단 부담 ({{100 - ratio}}%)</span>
                        <span class="font-18-400-gray">{{ setComma(maxPrice - exceedPrice - myPayment)}}원</span>
                    </div>
                    <div class="selected-info-row" style="padding: 0 16px; margin-top: 8px;">
                        <span class="font-18-400-gray">본인 부담 ({{ratio}}%)</span>
                        <span class="font-18-400-gray">{{setComma(myPayment)}}원</span>
                    </div>
                    <div class="selected-info-row" style="padding: 0 16px; margin-top: 16px;">
                        <span class="font-18-400-black">남은 지원금</span>
                        <span class="font-18-400-blue">{{maxFund - maxPrice > 0 ? setComma(maxFund - maxPrice) : 0}}원</span>
                    </div>
                    <div class="selected-info-row" style="padding: 0 16px; margin-top: 16px;">
                        <span class="font-18-400-black">초과 본인부담금</span>
                        <span class="font-18-400-red">{{ setComma(exceedPrice + etcPrice)}}원</span>
                    </div>
                    <div class="selected-info-row" style="padding: 0 16px; margin-top: 16px;margin-bottom: 158px;">
                        <span class="font-18-600-black"><span style="color: var(--Blue-01_Primary-blue, #008DEF);">*</span> 결제예정금액</span>
                        <span class="font-18-600-black">{{ setComma(exceedPrice + myPayment + etcPrice)}}원</span>
                    </div>
                </div>
            </div>
            <div class="copy-button-floating">
                <div class="selected-info-row">
                    <bottom-button 
                        :text="'결과 복사하기'"
                        :color="'var(--Gray-100, #1E1E1E)'"
                        @onClick="copyChat"
                        style="width: 100%;"
                    />
                </div>
            </div>

            <div class="floating" v-if="isCopyFloating">
                복사되었습니다!<br>붙여넣고 싶은 곳을 길게 눌러 ‘붙여넣기'를 선택해주세요.
                <img class="close" @click="closeFloating" src="../../../../assets/float-close.png" />
            </div>
        </div>
      
    </div>
</template>

<script>
//selected item
//count
//계산결과 
import Convert from '@/utilities/convert';
import html2canvas from 'html2canvas'
import axios from 'axios';
import BottomButton from '@/components/atoms/BottomButton';
import Loading from '@/components/molecules/Loading';


export default {
    name: 'resultDetail',
    props: ['dosageDay', 'type', 'isAdult', 'selectedItems', 'selectedCount', 'maxPrice', 'exceedPrice', 'myPayment', 'ratio', 'maxFund', 'etcPrice', 'diseaseType', 'autoInjector'],
    components: {BottomButton, Loading},
    data: function()
    {
        return {
            isLoading: false,
            isMobile: false,
            copy: null,
            isCopyFloating: false,
            link: 'https://naver.com'
        }
    },
    mounted: function()
    {
        ChannelIO('boot', {
            "pluginKey": "90e69520-1088-43c6-a1cc-3019437a9be8",
            "customLauncherSelector": ".custom-button-1",
            "hideChannelButtonOnBoot": true
        });
        this.isMobile = this.isMobileCheck();
    },
    methods: {
        convertDiabetesType: function(type)
        {
            if(type === 'T1')
            {
                return '1형당뇨'
            }
            else if(type === 'GESTATIONAL')
            {
                return '임신성 당뇨 (인슐린 투여)'
            }
            else if(type === 'GESTATIONAL_WITHOUT_INSULIN')
            {
                return '임신성 당뇨 (인슐린 미투여)'
            }
            else if(type === 'RARE_INTRACTABLE')
            {
                return '희귀난치성질환 대상자'
            }
            else if(type === 'SELF_CATHETER')
            {
                return '자가도뇨 카테터 대상자'
            }
            else if(type === 'NA')
            {
                return '해당없음'
            }
            else
            {
                return '2형당뇨'
            }
        },
        isMobileCheck: function() {
            return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        },
        onClose: function()
        {
            this.$emit('onClose')
        },
        nextStep: function()
        {
            this.save();
        },
        nextStepPC: function()
        {
            this.savePc();
        },
        copyChat() {    
            let text = `[카테터 비용 계산 결과] \n\n1. 환자유형 - ${this.convertDiabetesType(this.diseaseType)} \n2. 품목 - ${this.convertTypeToString(this.type)}\n3. 처방일수 - ${this.dosageDay === null ? '없음' : this.dosageDay}\n4. 제품정보\n${this.convertProductToString()}5. 계산결과\n${this.convertPriceToString()}` ;
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text)
                .then(() => {
                    this.isCopyFloating = true;

                    setTimeout(() => {
                        this.isCopyFloating = false;
                    }, 2000); // 2초 후 메시지 숨김
                })
                .catch(err => {
                    console.error('링크 복사 실패:', err);
                });
            } else {
                this.fallbackCopyText();
            }
        },
        convertProductToString: function()
        {
            let retStr = "";
            for(var i =0; i < this.selectedItems.length; i++)
            {
                retStr += `  • ${this.selectedItems[i].name} / ${this.selectedCount[i]}개\n`
            }

            return retStr;
        },
        convertPriceToString: function()
        {
            let retStr = `  • 총 금액 - ${this.setComma(this.maxPrice + this.etcPrice)}원\n  • 공단 부담 (${100 - this.ratio}%) - ${this.setComma(this.maxPrice - this.exceedPrice - this.myPayment)}원\n  • 본인 부담 (${this.ratio}%) - ${this.setComma(this.myPayment)}원\n  • 남은 지원금 - ${this.maxFund - this.maxPrice > 0 ? this.setComma(this.maxFund - this.maxPrice) : 0}원\n  • 초과 본인부담금 - ${ this.setComma(this.exceedPrice + this.etcPrice)}원\n  • 결제 예정 금액 - ${this.setComma(this.exceedPrice + this.myPayment + this.etcPrice)}원`;
            return retStr;
        },
        closeFloating: function()
        {
            this.isCopyFloating = false;
        },
        copyLink() {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(this.link)
                .then(() => {
                    this.isCopyFloating = true;

                    setTimeout(() => {
                        this.isCopyFloating = false;
                    }, 2000); // 2초 후 메시지 숨김
                })
                .catch(err => {
                    console.error('링크 복사 실패:', err);
                });
            } else {
                this.fallbackCopyText();
            }
        },
        fallbackCopyText() {
            // 오래된 브라우저 지원 (execCommand 방식)
            const textArea = document.createElement('textarea');
            textArea.value = this.link;
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                this.copied = true;
                setTimeout(() => {
                this.copied = false;
                }, 2000);
            } catch (err) {
                console.error('링크 복사 실패:', err);
            }
            document.body.removeChild(textArea);
        },
        setComma: function(data)
        {
            return Convert.setComma(data);
        },
        convertTypeToString: function(type)
        {
            if(type === -1)
            {
                return ''
            }
            else if(type === 0)
            {
                return '일반 소모성재료'
            }
            else if(type === 1)
            {
                return '연속혈당측정기'
            }
            else if(type === 2)
            {
                return '기타'
            }
            else if(type === 3)
            {
                return '관리기기'
            }
            else if(type === 4)
            {
                return '희귀난치성질환 의료기기'
            }
            else if(type === 5)
            {
                return '카테터'
            }
        },
        dataURLToBlob:function (dataURL) {
            const binaryString = atob(dataURL.split(",")[1]);
            const array = [];
            for (let i = 0; i < binaryString.length; i++) {
                array.push(binaryString.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], { type: "image/png" });
        },
        savePc: async function()
        {
            let _this = this;
            this.isLoading = true;
            html2canvas(document.getElementById('calculate-result')).then(async canvas => {
                const blob = _this.dataURLToBlob(canvas.toDataURL('image/png'));
                const file = new File([blob], "file.png", { type: "image/png" });

                const url = `${process.env.API_DB_ROOT}/diabetes/upload`; 
                const formData = new FormData();
                formData.append("file", file)
                const headers = {
                    "Content-Type": "multipart/form-data", // FormData를 사용할 때 필수
                    "secret": "soldoc-qazwsx123", // 필요 시 인증 토큰 추가
                };
                try {
                    // 3. 파일 업로드 요청
                    const response = await axios.put(url, formData, { headers });
                    _this.isLoading = false;
                    _this.link = `https://barodev.soldoc.co.kr/save?code=${response.data.data}`;
                    this.copyLink()

                    await navigator.share({
                        title: "파일 공유",
                        text: "이 파일을 공유합니다.",
                        url: `https://barodev.soldoc.co.kr/save?code=${response.data.data}`,
                    });

                    this.$emit('onClose')
                    console.log("Upload Success:", response.data);
                    
                } catch (error) {
                    this.$emit('onClose')
                    console.error("Upload Failed:", error);
                    throw error;
                }

            })
    
        },
        save: async function()
        {
        
            let _this = this;
            this.isLoading = true;
            html2canvas(document.getElementById('calculate-result')).then(async canvas => {
                const blob = _this.dataURLToBlob(canvas.toDataURL('image/png'));
                const file = new File([blob], "file.png", { type: "image/png" });

                const url = `${process.env.API_DB_ROOT}/diabetes/upload`; 
                const formData = new FormData();
                formData.append("file", file)
                const headers = {
                    "Content-Type": "multipart/form-data", // FormData를 사용할 때 필수
                    "secret": "soldoc-qazwsx123", // 필요 시 인증 토큰 추가
                };
                try {
                    // 3. 파일 업로드 요청
                    const response = await axios.put(url, formData, { headers });
                    _this.isLoading = false;
                    
                    Kakao.Share.sendDefault({
                        objectType: "feed",
                        content: {
                        title: "계산결과",
                        imageUrl:  `https://d3mz0r05sqimo9.cloudfront.net/calculator/${response.data.data}`, // Data URL 사용
                        link: {
                            mobileWebUrl: `https://barodev.soldoc.co.kr/save?code=${response.data.data}`,
                            webUrl: `https://barodev.soldoc.co.kr/save?code=${response.data.data}`,
                        },
                        },
                        buttons: [
                        {
                            title: "자세히 보기",
                            link: {
                                mobileWebUrl: `https://barodev.soldoc.co.kr/save?code=${response.data.data}`,
                                webUrl: `https://barodev.soldoc.co.kr/save?code=${response.data.data}`,
                            },
                        },
                        ],
                    });

                    this.$emit('onClose')
                    console.log("Upload Success:", response.data);
                    
                } catch (error) {

                    this.$emit('onClose')
                    console.error("Upload Failed:", error);
                    throw error;
                }
            })
        },
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFFFFF;
        z-index: 10;
        top: 0;
        left: 0;

    }
    .contents {
        max-width: 600px;
        width: 100%;
        height: 100dvh;
        z-index: 2000;
        box-sizing: border-box;
        overflow-y: auto;
    }
    .result-header {
        width: 100%;
        height: 49px;
        padding: 13px 16px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .selected-area {
        width: 100%;
        box-sizing: border-box;
        background: var(--Gray-sub-color1, #F3F5F8);
        padding: 20px;
    }
    .selected-area-info {
        width: 100%;
        border-radius: 6px;
        background: #FFF;
        box-sizing: border-box;
        padding: 22px 20px;
        display: flex;
        flex-direction: column;
    }
    .selected-info-row {
        display: flex;
        box-sizing: border-box;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }
    .selected-info-label {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .selected-info-value {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .product-area {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 16px 5px 16px;
        background: var(--Gray-00, #FFF);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        border-bottom: 8px solid var(--Gray-sub-color1, #F3F5F8);
    }
    .product-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px; /* 110% */
    }
    .product-name {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 82%;
    }
    .product-count {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .payment-area {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .payment-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px; /* 110% */
        box-sizing: border-box;
        width: 100%;
        height: 62px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 16px;
        border-bottom: 1px solid #D1D6DB;;
    }
    .font-18-600-black {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
    }
    .font-18-400-black {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .font-18-400-blue {
        color: var(--Blue-01_Primary-blue, #008DEF);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .font-18-400-red {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .font-18-400-gray {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }

    .custom-button-1 {
        width: 56px;
        height: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;              
        background: #184FA1;
        width: 114px;
        height: 34px;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        cursor: pointer;
    }
    .floating {
        width: calc(100% - 32px);
        max-width: calc(568px);
        position: fixed;
        z-index: 999;
        border-radius: 6px;
        background: var(--Gray-60, #6B7684);
        backdrop-filter: blur(2px);
        height: 57px;
        left: 50%;
        bottom: 96px;
        transform: translate(-50%, 0);
        padding: 0 30px 0 20px;
        box-sizing: border-box;
        color: #FFF;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .close {
        position: absolute;
        top: 17px;
        right: 8px;
        width: 22px;
        cursor: pointer;
    }
    .copy-button-floating {
        position: fixed;
        width: calc(100% - 32px);
        max-width: calc(568px);
        position: fixed;
        z-index: 999;
        transform: translate(-50%, 0);
        left: 50%;
        bottom: 32px;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/calculator/catheter/ResultDetail.vue